'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactTransitionGroup = require('react-transition-group');

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

var _reactEventListener = require('react-event-listener');

var _reactEventListener2 = _interopRequireDefault(_reactEventListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var label = null,
        selected = this._getSelected(),
        classList = this.compileStyle(_index2.default),
        value = void 0,
        title = void 0,
        list = null;

    if (this.props.label) {
        label = _react2.default.createElement(
            'label',
            { className: classList.label },
            this.props.label
        );
    }

    if (this._preparedList.length) {
        value = selected ? selected.name : this.props.placeholder;
    } else {
        value = this.props.emptyListPlaceholder;
    }

    var isValueReactComponent = _react2.default.isValidElement(value);

    if (!isValueReactComponent) {
        value = _l10n2.default.translate(value);
    }

    if (!isValueReactComponent) {
        title = _l10n2.default.translate(value);
    } else if (selected && isValueReactComponent) {
        title = _l10n2.default.translate(selected.stringName);
    }

    if (this.state.active) {
        var listStyle = {};

        if (this.state.maxHeight) {
            listStyle.maxHeight = this.state.maxHeight;
        }

        if (this.state.maxWidth) {
            listStyle.maxWidth = this.state.maxWidth;
        }

        list = this._preparedList.map(function (item) {
            var isReactComponent = _react2.default.isValidElement(item.name),
                stringName = isReactComponent ? _l10n2.default.translate(item.stringName) : _l10n2.default.translate(item.name);

            return _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    title: stringName,
                    key: 'item-' + item.id,
                    onClick: function onClick(e) {
                        return _this.select(item.id);
                    },
                    onKeyDown: _this._keymap.bind(_this),
                    onBlur: _this._handleBlur.bind(_this),
                    role: 'drop-item',
                    tabIndex: '-1',
                    className: selected && item.id === selected.id ? classList.itemSelected : classList.item,
                    'data-qa-node': _this.props.attribute + '-option',
                    'data-qa-value': stringName
                },
                _react2.default.createElement(
                    'span',
                    null,
                    isReactComponent ? item.name : stringName
                )
            );
        });

        list = _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
                component: 'div',
                classNames: classList.animation,
                timeout: 450,
                key: 'list'
            },
            _react2.default.createElement(
                'div',
                {
                    className: classList.list + ' ' + classList.animation,
                    ref: this._listRef.bind(this),
                    tabIndex: '-1',
                    style: listStyle,
                    'data-qa-node': this.props.attribute + '-list'
                },
                list
            )
        );
    }

    return _react2.default.createElement(
        'div',
        {
            className: classList.root + ' ' + (this.props.className || ''),
            ref: this._rootRef.bind(this),
            onMouseEnter: this._handleHover.bind(this),
            onMouseLeave: this._handleRootBlur.bind(this)
        },
        _react2.default.createElement(_reactEventListener2.default, {
            target: window.document.querySelector('body'),
            onClick: this._handleBodyClick.bind(this)
        }),
        label,
        _react2.default.createElement(
            'div',
            { className: classList.input },
            _react2.default.createElement(
                'button',
                {
                    className: classList.fieldWrapper,
                    type: 'button',
                    title: title,
                    onClick: this.open.bind(this),
                    onKeyDown: this._handleFocusList.bind(this),
                    ref: this._nativeRef.bind(this),
                    'data-qa-node': this.props.attribute,
                    'data-qa-value': title
                },
                _react2.default.createElement(
                    'span',
                    { className: selected ? classList.field : classList.placeholder },
                    _react2.default.createElement(
                        'span',
                        { className: classList.overflowWrapper },
                        value
                    )
                ),
                _react2.default.createElement('span', { className: classList.icon })
            ),
            _react2.default.createElement(
                _reactTransitionGroup.TransitionGroup,
                null,
                list
            )
        ),
        _react2.default.createElement('hr', { className: classList.border }),
        _react2.default.createElement('hr', { className: classList.activeBorder })
    );
}